export default __webpack_public_path__ + "static/media/doctor-small.58c1a457.png";